/* DOCUMENT READY */

$(function() {
    if ($("h1.cart_main_title.basket")) {
        var h1 = $("h1.cart_main_title.basket");

        h1.replaceWith('<span class="cart_main_title basket">' + h1.html() + '</span>');
    }

    // MODULES ADV
    if ($('.cms-page-module.four-images .swiper').length) {
        var cmsPageFourImages = new Swiper('.cms-page-module.four-images .swiper', {
            slidesPerView: 2.5,
            spaceBetween: 24,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1020: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                1100: {
                    slidesPerView: 1.35,
                    slidesPerGroup: 1.35,
                },
                1450: {
                    slidesPerView: 1.5,
                    slidesPerGroup: 1.5,
                },
                1700: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                }
            },
        });
    }

    // Header Burger Menu
    $('.burger_menu_container').click(function() {
        $('.burger_menu').toggleClass('is_clicked');
        $('.bot_header_wrapper').toggleClass('is_open');
        $('#shad_menu').addClass('actif');
        $('#header_mention_id, .header').toggleClass('nav_burger_open');
        $('.burger_menu_close').addClass('visible');
        $('.ss_menu_categ_wrapper').overlayScrollbars({
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 0,
            }
        });
    });

    $('.burger_menu_close').click(function() {
        $('.burger_menu').toggleClass('is_clicked');
        $('.bot_header_wrapper').toggleClass('is_open');
        $('#shad_menu').removeClass('actif');
        $('#header_mention_id, .header').toggleClass('nav_burger_open');
        $(this).removeClass('visible');
        closeBurgerSubMenu();
    });

    /* Menu adv en burger (<= 1024px) : sous-menu, retour, accordéon des sous-rayons */
    function isBurgerViewport() {
        return window.matchMedia('(max-width: 1024px)').matches;
    }

    function closeBurgerSubMenu() {
        $('.main-menu .rollover-menu[is-visible]').removeAttr('is-visible');
        $('.main-menu .rollover-menu-wrapper').removeAttr('is-boutique');
        $('.main-menu .menu-boutique[is-opened]').removeAttr('is-opened');
    }

    $('.burger_menu_container').on('click', function() {
        if (!$('.header').hasClass('nav_burger_open')) {
            closeBurgerSubMenu();
        }
    });

    /* Burger ouvert (<= 1024px) : page verrouillée, seul le menu défile (hauteur du panneau calée via --burger-top) */
    var burgerHeader = document.getElementById('site_head_wrap');

    function syncBurgerScrollLock() {
        var panel = document.querySelector('.header_main_wrapper');
        var locked = !!burgerHeader && burgerHeader.classList.contains('nav_burger_open') && isBurgerViewport();

        if (locked && panel) {
            document.documentElement.style.setProperty('--burger-top', Math.max(0, Math.round(panel.getBoundingClientRect().top)) + 'px');
        }
        document.documentElement.classList.toggle('burger_open', locked);
    }

    if (burgerHeader && window.MutationObserver) {
        new MutationObserver(syncBurgerScrollLock).observe(burgerHeader, { attributes: true, attributeFilter: ['class'] });
        window.addEventListener('resize', syncBurgerScrollLock);
    }

    /* Capture : passe avant la navigation du lien */
    document.addEventListener('click', function(e) {
        if (!isBurgerViewport() || !e.target || !e.target.closest) return;

        var wrapper = e.target.closest('.main-menu .rollover-menu-wrapper');
        if (!wrapper) return;

        var returnBtn = e.target.closest('.menu-return');
        if (returnBtn) {
            e.preventDefault();
            e.stopPropagation();
            closeBurgerSubMenu();
            return;
        }

        var boutique = e.target.closest('.menu-boutique');
        if (boutique) {
            var subRayon = $(boutique).next('.sub-rayon')[0];
            if (!subRayon) return;

            e.preventDefault();
            e.stopPropagation();
            if (boutique.hasAttribute('is-opened')) {
                boutique.removeAttribute('is-opened');
            } else {
                $(boutique).closest('.menu-col').find('.menu-boutique[is-opened]').removeAttr('is-opened');
                boutique.setAttribute('is-opened', '');
            }
            return;
        }

        var superLink = e.target.closest('.menu-super');
        if (superLink) {
            var subMenu = $(superLink).closest('.rollover-super-wrapper').children('.rollover-menu')[0];
            if (!subMenu) return;

            e.preventDefault();
            e.stopPropagation();
            $('.main-menu .rollover-menu[is-visible]').not(subMenu).removeAttr('is-visible');
            subMenu.setAttribute('is-visible', '');
            wrapper.setAttribute('is-boutique', '');
        }
    }, true);

    /* BACK TO TOP FUNCTION */
    var stickyNavEl = $('#rayon_sticky_nav');
    var backToTopBtn = $('#back_to_top');

    if (stickyNavEl.length > 0) {
        var stickyNavTop = stickyNavEl.offset().top;
    }

    function stickyNav() {
        if (stickyNavEl.length > 0) {
            var scrollTop = $(window).scrollTop(); // our current vertical position from the top

            if (scrollTop > stickyNavTop) {
                stickyNavEl.addClass('sticky');
                $("#cart_top").appendTo(".filters_left");

            } else {
                stickyNavEl.removeClass('sticky');
                $("#cart_top").appendTo(".rightSide");
            }
        }
    };

    stickyNav();

    $(window).scroll(function () {
        stickyNav();

        if ($(window).scrollTop() > 300) {
            backToTopBtn.addClass('show');
        } else {
            backToTopBtn.removeClass('show');
        }
    });

    backToTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 500, 'linear');
    });

    //toggle filtre cms page journal
    $('.cms_menu_item.filter .bgSprite').click(function() {
        $('.cms_menu_item.filter').toggleClass("open");
    });

    // w-login-form insertAfter
    if ($(".w-newlogin-form").length && !$('body').hasClass('in_tunnel')) {
        $("p.legal_notices").insertAfter(".login_form_wrapper .title .subtitle.cache").show();
    }

    // Toggle the visibility of the 'back_to_top' element based on mouse events.
    $('.rolloverTxt').on('mouseenter', function () {
        if ($('#back_to_top').hasClass('show')) {
            setTimeout(function() {
                if ($('.header_rightSide').hasClass('hover')) {
                    $('#back_to_top').removeClass('show');
                }
            }, 100);
        }
    });

    $('#show_top_cart, .header_rightSide, .connexion_to').on('mouseleave', function () {
        setTimeout(function() {
            if (!$('#show_top_cart').hasClass('hover') && !$('.header_rightSide').hasClass('hover') && !$('.connexion_to').hasClass('hover')) {
                $('#back_to_top').addClass('show');
            }
        }, 100);
    });

    updateRolloverCartPosition();
    $(window).resize(updateRolloverCartPosition);
    $(window).scroll(updateRolloverCartPosition);

    // Gift Card
    if ($('#formGiftCard #cardCode').length) {
        $('#formGiftCard #cardCode').after('<span class="ico" onclick="toggleGiftCardGuide()"></span>');
    }

    if ($('#orderGiftCardForm #send_date').length) {
        // Set default datepicker language to French
        if ($('body').hasClass('fr')) {
            $.datepicker.setDefaults($.datepicker.regional['fr']);
        } else {
            $.datepicker.setDefaults($.datepicker.regional['en']);
        }

        $('#send_date').datepicker({
            minDate: 0
        });
    }

    if ($('#orderGiftCardForm #send_time').length) {
        var now = new Date();
        var availabelTime = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');

        $('#send_time').timepicker({
            timeFormat: 'HH:mm',
            minTime: availabelTime,
            interval: 30,
            dynamic: false,
            dropdown: true,
            scrollbar: true,
            change: function() {
                if ($('#send_time').hasClass('inputErr')) {
                    $('#send_time').removeClass('inputErr');
                    $('#time_warning').hide();
                }
            }
        });
    }

    if ($('.add_sticky_giftcard').length) {
        // On scroll and resize events to toggle the sticky gift card add to cart
        $(window).on('scroll resize', toggleStickyGiftcard);

        // Initialize the sticky gift card add to cart functionality
        toggleStickyGiftcard();
    }
});

// Function to check if an element is in the viewport
function isElementInViewport(el) {
    if (!el.length) return false;

    var rect = el[0].getBoundingClientRect();

    // If the top of the element is less than 50px from the top,
    // consider it not in viewport as the header is fixed
    if (rect.top < 50) return false;

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Function to toggle the visibility of the sticky gift card add to cart based on the form's CTA position
function toggleStickyGiftcard() {
    var $validCardForm = $('#js-submitStep2');
    var $stickyGiftcard = $('.add_sticky_giftcard');

    if (!$validCardForm.length) return;
    if (!isElementInViewport($validCardForm)) {
        $stickyGiftcard.addClass('show');
    } else {
        $stickyGiftcard.removeClass('show');
    }
}

function toggleGiftCardGuide() {
    var guide = $('#showCardGuide');

    if (guide.is(':visible')) {
        guide.hide();
    } else {
        guide.show();
    }
}

//Set rollover panier position when preheader & GBE banner present
function updateRolloverCartPosition() {
    const preheaderHeight = $('#header_mention_id').length && $('#header_mention_id').css('display') !== 'none'? $('#header_mention_id').outerHeight(): 0;
    const gbeBannerHeight = $('#FreeShippingBanner').length ? $('#FreeShippingBanner').outerHeight() : 0;
    // Get the height of #top_wrapper
    const topWrapperHeight = $('#top_wrapper').outerHeight();
    // Calculate the total height
    const totalHeight = preheaderHeight + topWrapperHeight + gbeBannerHeight;
    // Apply the total height as the "top" style for #show_top_cart
    $('#cart_top').css('--totalHeight', totalHeight + 'px');
    // Apply the total height as the "top" style for .wrap_search_field
    $('.wrap_search_field').css('top', totalHeight + 'px');
    // Apply the total height as the "top" style for #topLogin
    $('#topLogin').css('--totalHeight', totalHeight + 'px');

    const $headerEl = $('#site_head_wrap').length ? $('#site_head_wrap') : $('#site_head');
    const headerHeight = $headerEl.outerHeight() || totalHeight;
    document.documentElement.style.setProperty('--headerTotalHeight', headerHeight + 'px');
}

/* FUNCTIONS */
function processDisplayProductInList(obj, result) {
    let hasStock = false

    Object.keys(result).forEach(function(key) {
        // Checks if the key is a valid colorId (the string must be a number)
        if (!isNaN(parseInt(key)) && isFinite(key)) {
            let colorId = key;

            // Updates the stock availability for each size
            Object.keys(result[colorId]).forEach(function (sizeId) {
                if (result[colorId][sizeId]) {
                    hasStock = true;
                    obj.find('[name="itm_size"]').filter('[value="' + sizeId + '"]').removeClass('disabled');
                } else {
                    obj.find('[name="itm_size"]').filter('[value="' + sizeId + '"]').addClass('disabled');
                }
            });
        }
    });

    if (hasStock) {
        obj.removeClass('reminder_on');
    } else {
        obj.addClass('reminder_on');
        obj.find('.searchProductNoStockOverlay').show();
    }
}

/* TRIGGER SHAD */
function triggerShad(shad, action) {
    shad = shad ? ('#shad_' + shad):'#shad' ;

    if (action && action == 'add') {
        $(shad).addClass('actif');
    } else if (action) {
        $(shad).removeClass('actif');
    } else {
        return;
    }
}

function initProductFieldset(id) {

    /*  Function to simulate the behavior of a select */
    var listColorSize = $("#" + id +".choices_list ");

    listColorSize.addClass("opened");
    $('body').addClass("noScroll");
}

function exitProductFieldset(id) {
    var listColorSize;
    if (id !== undefined) {
        /*  Function to simulate the behavior of a select */
        listColorSize= $("#" + id +".choices_list");
    } else{
        listColorSize= $(".choices_list.opened");
    }
    listColorSize.removeClass("opened");
    $('body').removeClass("noScroll");
}

/* Pop-in panier added 2 sizes same product */
function mySubmit(pType) {
    $(".cartLoader").addClass("loading");
    var form = document.getElementById("formPanier");

    form.action = create_link("order_basket");

    setTimeout(function () {
        form.submit();
    }, 500);
}
